import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(
    private http: MiraieService,
  ) { }

  getQuestionList(question_no) {
    var url = "question/get";

    return this.http.post(url, {question_no} );
  }

  /**
   * アンケート項目の更新
   */
  updateQuestionList(questionList) {
    var url = 'question/update';

    return this.http.post(url, questionList);
  }

  saveQuestionAnswer(answer){
    var url = 'question/answer';

    return this.http.post(url, answer);
  }
}
